module.exports = __webpack_public_path__ + "img/honey.417afdf1.jpg";